(function( $ ) {
    $(function() {
        //Match Height
        $('.eq-foot-col').matchHeight();
        $('.eq-menu').matchHeight();
        $('.timeline-container .custom-col').matchHeight();
        $('.top-blocks .content-wrapper').matchHeight();
        $('.eq-actual-item').matchHeight();
        
        $('.eq-home-col').matchHeight();
        
        // toggle menu icon
        $('.menu-toggler').on('click', function(){            
            $('.search-container').removeClass('open');
            $('.search-toggler').removeClass('open');
            
            $(this).toggleClass('open');
            $('.ham-icon').toggleClass('open');
            $('.navs-container').toggleClass('open');
        });
        $('.search-toggler').on('click', function(){
            $('.menu-toggler').removeClass('open');
            $('.ham-icon').removeClass('open');
            $('.navs-container').removeClass('open');
            
            $(this).toggleClass('open');
            $('.search-container').toggleClass('open');
        });
        //Certs
        function selectLocationCert(){
            if($('.location-select').length > 0){
                var selectVal = $('.location-select option:selected').val();
                $('.cert-table .info-table').eq(selectVal).show().siblings('.info-table').hide();
                //console.log(selectVal);
            }           
        }
        selectLocationCert();
        $('.location-select').on('change', function(){
            selectLocationCert();
        });
        
        //scroll to anchors
        $('a[href*=#]:not([href=#])').click(function(e) {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                var headerBoxHeight_ = $('.main-header').outerHeight(true);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');                    
                if (target.length) {
                    $('html,body').animate({
                            scrollTop: target.offset().top - headerBoxHeight_
                    }, 1000);
                    return false;
                }
            }
        });
        //Slider
        function getContentPos (){
            //var positionVar;
            $('.single-slide').each(function(){
                var El = $(this).find('.content-wrapper');
                if(El.length > 0){
                    var heightEL = El.outerHeight(true);
                    var widthEL = El.outerWidth(true);                    
                    var parentHeight = El.parent().height();
                    var topOffset = parentHeight - heightEL;
                    var leftOffset = ($(window).width() - ($('.row').width() - 30))/2 + widthEL;
                    
                    $('.navigation-wrapper').css('left', leftOffset+'px');
                    //$('.navigation-wrapper').css('top', topOffset+'px');
                    //positionVar = El.position();
                }
            });
        }
        
        $('.steps-slider-vertical').on('init', function(event, slick){
            getContentPos();
        });
        $(window).on('resize', function(){
            getContentPos();
        });
        var navItemArr = $('.navigation-wrapper .item');
        function toggleSlides (){
            //this to nav item
            var thisSlideItem = $(this);
            $(this).addClass('active').siblings().removeClass('active');
            $('.steps-slider-vertical').slick( 'slickGoTo', parseInt(thisSlideItem.attr('data-navslide')) );
        }
        navItemArr.on('click',toggleSlides);
        function YouTubeGetID(url){
            var ID = '';
            url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if(url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            }
            else {
                ID = url;
            }
            return ID;
        }
        //Init Slider
        $('.steps-slider-vertical').on('init', function(slick){
            var firstSlideVideo = $(this).find('.slick-slide:first-child .video-wrapper iframe');
            if(firstSlideVideo.length > 0){
                var attrIframe = firstSlideVideo.attr('src');
                attrIframe += '&autoplay=1&mute=1&loop=1&playlist='+YouTubeGetID(attrIframe);
                firstSlideVideo.attr('src', attrIframe);
                firstSlideVideo.animate({opacity:1}, 1000);
            }
            $('.navigation-wrapper').hide();
            //console.log($(this));
        });        
        //Before slider change        
        $('.steps-slider-vertical').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            navItemArr.off('click');
            $('.next-slide').off('click');
            var slideCurrent =  $('.steps-slider-vertical').find('.slick-slide').eq(currentSlide);
            var slideNext =  $('.steps-slider-vertical').find('.slick-slide').eq(nextSlide);
            if(slideCurrent.length > 0){
                var iframeCurrent = slideCurrent.find("iframe");
                if(iframeCurrent.length > 0){
                    var iframeSrcCurrent = iframeCurrent.attr("src")+'&autoplay=0';
                    iframeCurrent.attr("src", iframeSrcCurrent);
                }
                iframeCurrent.animate({opacity:0}, 1000);
            }
            if(slideNext.length > 0){
                var iframeNext = slideNext.find("iframe");
                if(iframeNext.length > 0){
                    var iframeSrcNext = iframeNext.attr("src")+'&autoplay=1&mute=1&loop=1&playlist='+YouTubeGetID(iframeNext.attr("src"));
                    iframeNext.attr("src", iframeSrcNext);
                    iframeNext.animate({opacity:0}, 1000);
                }
            }
            document.removeEventListener( 'DOMMouseScroll', this, false);
        });
        //After Slider Change
        $('.steps-slider-vertical').on('afterChange', function(event, slick, currentSlide){
            navItemArr.on('click', toggleSlides);
            $('.next-slide').on('click', nextBtnClick);
            $('.navigation-wrapper .item[data-navslide="'+currentSlide+'"]').addClass('active').siblings().removeClass('active');
            if(currentSlide == 0){
                navItemArr.removeClass('active');
            }
            if( (slick.slideCount - currentSlide) == 1 ){
                $('.next-slide').addClass('last');
                $('.scroll-txt-wrapper').fadeOut();
            }
            else {
                $('.next-slide').removeClass('last');
                $('.scroll-txt-wrapper').fadeIn();
            }            
            //Custom nav
            setTimeout(function(){
                $('.steps-slider-vertical').find('.slick-slide').eq(currentSlide).find('iframe').animate({opacity:1}, 500);
            }, 1000);
            
            $('.steps-slider-vertical .custom-slider-navs').on('click', '.slide-nav', function(){
                if($(this).hasClass('prev-slide')) {
                    $('.steps-slider-vertical').slick('slickPrev');
                }
                if($(this).hasClass('next-slide')) {
                    $('.steps-slider-vertical').slick('slickNext');
                }
            });
//            var firstSlideVideo = $(this).find('.slick-slide.slick-active .video-wrapper iframe');
//            if(firstSlideVideo.length > 0){
//                var attrIframe = firstSlideVideo.attr('src');
//                attrIframe += '&autoplay=1&mute=1&loop=1&playlist='+YouTubeGetID(attrIframe);
//                firstSlideVideo.attr('src', attrIframe);
//            }
            
            document.addEventListener( 'DOMMouseScroll', function( e ) {
                handleMouseWheelDirection( detectMouseWheelDirection( e ) );
            });
            
            if(currentSlide == 0) {
                $('.navigation-wrapper').hide();
            }
            else {
                $('.navigation-wrapper').show();
            }
        });
        function nextBtnClick(){            
            if($(this).hasClass('last')){
                $('.steps-slider-vertical').slick('slickGoTo', 0);
            }
            else {
                $('.steps-slider-vertical').slick('slickNext');
            }            
        }
        $('.next-slide').on('click', nextBtnClick);
        
        //Mouse scroll
        function detectMouseWheelDirection( e ) {
            var delta = null,
                direction = false
            ;
            if ( !e ) { // if the event is not provided, we get it from the window object
                e = window.event;
            }
            if ( e.wheelDelta ) { // will work in most cases
                delta = e.wheelDelta / 60;
            } else if ( e.detail ) { // fallback for Firefox
                delta = -e.detail / 2;
            }
            if ( delta !== null ) {
                direction = delta > 0 ? 'up' : 'down';
            }
            return direction;
        }
        function handleMouseWheelDirection( direction ){
            //console.log( direction ); // see the direction in the console
            if ( direction == 'down' ) {
                // do something, like show the next page
                $('.steps-slider-vertical').slick('slickNext');
                
            } else if ( direction == 'up' ) {
                // do something, like show the previous page
                $('.steps-slider-vertical').slick('slickPrev');
            } else {
                // this means the direction of the mouse wheel could not be determined
            }
        }
        function scrollingSlider() {
            if( ($('.steps-slider-vertical').length > 0) ){
                
                if ( window.addEventListener ) {
                    if( $(window).width() > 935 ){                        
                        document.onmousewheel = function( e ) {
                            handleMouseWheelDirection( detectMouseWheelDirection( e ) );
                        };
                        document.addEventListener( 'DOMMouseScroll', function( e ) {
                            handleMouseWheelDirection( detectMouseWheelDirection( e ) );
                        });
                    }
                    else {
                        document.onmousewheel = '';
                        document.removeEventListener( 'DOMMouseScroll', this, false);
                    }
                    
                }                                
            }
        }
        scrollingSlider();
        $(window).on('resize', function(){
            scrollingSlider();
        });
        $('.steps-slider-vertical').slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: true,
            //nextArrow: '<button type="button" class="slick-next"></button>',
            verticalSwiping: true,
            adaptiveHeight: true,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        //vertical: false,
                        verticalSwiping: false,
                    }
                }
            ]
        });
        if ( window.location.hash ) {
            scroll(0,0);
            setTimeout( function() { scroll(0,0); }, 1);
        }
        //Home anim
        $('.dot-home-cirle').on('click', function(e){            
            e.preventDefault();
            var thisDot = $(this);
            thisDot.closest('.dot-home-item').addClass('active').siblings().removeClass('active');
        });
        $('.dot-home-item').eq(0).addClass('active');
        setInterval(function(){
            var next = $('.dot-home-item.active').removeClass('active').next();
            if (next.length) {
                next.addClass('active');
            }
            else {
                $('.dot-home-item:first').addClass('active');
            }
            //$('.dot-home-item.active').removeClass('active').next().addClass('active');
        }, 2000);
        $(window).load(function(){
            //links to anchors on window load
            var headerOffset = $('.main-header').outerHeight(true);
            
            var hash = window.location.hash;
            if(hash.length > 0) {
                var target = $('[id=' + window.location.hash.slice(1) +']');                
                target.click();
                $('html,body').animate({
                    scrollTop: target.offset().top - headerOffset
                }, 1000);            
            }        
        });
        $(window).load(function () {
            $('body').animate({opacity: 1}, 1000);}
        );
        //Sticky Header
        // grab an element
        var myElement = document.querySelector(".main-header");
        // construct an instance of Headroom, passing the element
        var headroom  = new Headroom(myElement, {
            "offset" : 150
        });
        function setBodyOffset(){
            var headerHeight = $('.main-header').outerHeight(true) - $('#wpadminbar').outerHeight(true);
            $('body').css('margin-top', headerHeight+'px');
        }
        setBodyOffset();
        $(window).on('resize', function(){
            setBodyOffset();
        });
        // initialise
        headroom.init();
    });
})(jQuery);